/*eslint-disable*/
export const getUserObject = (state) => state.userProfile.userObj

export const getUserCallStatus = (state) => state.userProfile.status

export const getUserCallError = (state) => state.userProfile.error
